import BpkBreakpoint from '@skyscanner/backpack-web/bpk-component-breakpoint';

import type { UserContext } from '@shared/types/user-context';

import { getMatchSSR } from '@shared/utils-frontend/breakpoint';
import { withUserContext } from '@shared/utils-frontend/contexts/UserContext';

type Props = {
  query: string;
  children: (isActive: boolean) => React.ReactNode | null;
  userContext: UserContext;
};

const BpkBreakpointWrapper = ({ children, query, userContext }: Props) => {
  const matchSSR = getMatchSSR(query, userContext);

  return (
    <BpkBreakpoint query={query} matchSSR={matchSSR}>
      {children}
    </BpkBreakpoint>
  );
};

export default withUserContext(BpkBreakpointWrapper);
